import { Head } from '@/components/seo/Head/Head';
import { ErrorScreen } from '@/components/shared/ErrorScreen/ErrorScreen';
import { ForgotUsernameList } from '@/features/auth/components/ForgotUsernameList/ForgotUsernameList';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';

export const ForgotUsernameListRoute = () => {
  const { t } = useTranslation('auth', { keyPrefix: 'forgotUsernameList' });

  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  if (!token) {
    return <ErrorScreen withSeoTitle />;
  }

  return (
    <>
      <Head title={t('seo.title')} />
      <ForgotUsernameList token={token} />
    </>
  );
};
